import { render } from "./verifyEmail.vue?vue&type=template&id=0c16ff4f&scoped=true"
import script from "./verifyEmail.vue?vue&type=script&lang=js"
export * from "./verifyEmail.vue?vue&type=script&lang=js"

import "./verifyEmail.vue?vue&type=style&index=0&id=0c16ff4f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c16ff4f"]])

export default __exports__